module.exports = __webpack_public_path__ + "img/jeepay.3067ac81.svg";